"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiddleAlignedSpan = exports.StyledButton = exports.sizeHandler = void 0;
var components_1 = require("@wordpress/components");
var styled_components_1 = __importDefault(require("styled-components"));
var size_calculator_1 = require("../../utils/size-calculator");
var button_type_1 = require("./button-type");
function sizeHandler(size, values, baseFontSize, isFont) {
    var _a, _b, _c, _d;
    if (baseFontSize === void 0) { baseFontSize = 16; }
    if (isFont === void 0) { isFont = false; }
    if (isFont) {
        return (0, size_calculator_1.fontSizeCalc)((_b = (_a = values[size]) !== null && _a !== void 0 ? _a : values.default) !== null && _b !== void 0 ? _b : 0);
    }
    return (0, size_calculator_1.sizeCalc)((_d = (_c = values[size]) !== null && _c !== void 0 ? _c : values.default) !== null && _d !== void 0 ? _d : 0, baseFontSize);
    // return values[size] ?? values.default ?? '';
}
exports.sizeHandler = sizeHandler;
exports.StyledButton = (0, styled_components_1.default)(components_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    border-radius: ", ";\n    font-size: ", ";\n    font-weight: 600;\n    cursor: pointer;\n    align-items: center;\n    box-shadow: none;\n    padding-block: 0;\n\n    display: ", ";\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n    padding-inline: ", ";\n    height: ", ";\n\n    & > svg {\n      margin-inline: ", ";\n      order: ", ";\n      width: ", ";\n      height: ", ";\n      fill: ", ";\n    }\n\n    &:hover {\n      box-shadow: none !important;\n\n      color: #fff;\n\n      & > svg {\n        fill: #fff;\n      }\n    }\n\n    &:focus {\n      box-shadow: none !important;\n    }\n\n    &[disabled] {\n      cursor: not-allowed;\n      background-color: ", ";\n      border: ", ";\n      color: ", ";\n\n      & > svg {\n        fill: ", ";\n      }\n    }\n\n    &.is-small.has-icon:not(.has-text) {\n      padding-inline: ", ";\n      width: unset;\n    }\n\n    &.has-icon {\n      min-width: unset;\n    }\n  }\n\n  &.ripple:not([disabled]) {\n    background-position: center;\n    transition: background 0.8s !important;\n\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background-color: ", " !important;\n      background-size: 100% !important;\n      transition: background 0s !important;\n    }\n  }\n"], ["\n  &&& {\n    border-radius: ", ";\n    font-size: ", ";\n    font-weight: 600;\n    cursor: pointer;\n    align-items: center;\n    box-shadow: none;\n    padding-block: 0;\n\n    display: ", ";\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n    padding-inline: ", ";\n    height: ", ";\n\n    & > svg {\n      margin-inline: ", ";\n      order: ", ";\n      width: ", ";\n      height: ", ";\n      fill: ", ";\n    }\n\n    &:hover {\n      box-shadow: none !important;\n\n      color: #fff;\n\n      & > svg {\n        fill: #fff;\n      }\n    }\n\n    &:focus {\n      box-shadow: none !important;\n    }\n\n    &[disabled] {\n      cursor: not-allowed;\n      background-color: ", ";\n      border: ", ";\n      color: ", ";\n\n      & > svg {\n        fill: ", ";\n      }\n    }\n\n    &.is-small.has-icon:not(.has-text) {\n      padding-inline: ", ";\n      width: unset;\n    }\n\n    &.has-icon {\n      min-width: unset;\n    }\n  }\n\n  &.ripple:not([disabled]) {\n    background-position: center;\n    transition: background 0.8s !important;\n\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background-color: ", " !important;\n      background-size: 100% !important;\n      transition: background 0s !important;\n    }\n  }\n"])), (0, size_calculator_1.sizeCalc)(12, 14), (0, size_calculator_1.fontSizeCalc)(14), function (props) { return (props.iconPosition === button_type_1.ButtonIconPosition.END ? 'inline-flex' : 'inline-block'); }, function (props) {
    if (props.variant === button_type_1.ButtonVariant.SECONDARY) {
        return 'transparent';
    }
    return props.color === button_type_1.ButtonColor.RED ? '#D83C2B' : '#2E9E62';
}, function (props) {
    if (props.variant === button_type_1.ButtonVariant.PRIMARY) {
        return 'none';
    }
    return props.color === button_type_1.ButtonColor.RED ? "".concat((0, size_calculator_1.sizeCalc)(1, 14), " solid #D83C2B") : "".concat((0, size_calculator_1.sizeCalc)(1, 14), " solid #2E9E62");
}, function (props) { return (props.variant === button_type_1.ButtonVariant.PRIMARY ? '#fff' : '#002729'); }, function (props) {
    var _a = props.size, size = _a === void 0 ? button_type_1.ButtonSize.MEDIUM : _a, children = props.children;
    if (!children) {
        return sizeHandler(size, {
            default: 14,
            large: 14,
            medium: 11.5,
            small: 12,
            xSmall: 8,
            xxSmall: 5
        }, 14);
    }
    return sizeHandler(size, {
        default: 24,
        small: 16,
        xSmall: 12,
        xxSmall: 12
    }, 14);
}, function (props) {
    var _a = props.size, size = _a === void 0 ? button_type_1.ButtonSize.MEDIUM : _a;
    return sizeHandler(size, {
        large: 54,
        medium: 49,
        small: 42,
        xSmall: 34,
        xxSmall: 28
    }, 14);
}, function (props) {
    var text = props.text, children = props.children, iconPosition = props.iconPosition;
    if (!children && !text) {
        return undefined;
    }
    return iconPosition === button_type_1.ButtonIconPosition.END ? "".concat((0, size_calculator_1.sizeCalc)(10), " 0") : "0 ".concat((0, size_calculator_1.sizeCalc)(10));
}, function (props) { return (props.iconPosition === button_type_1.ButtonIconPosition.END ? '1' : undefined); }, function (props) {
    var _a = props.size, size = _a === void 0 ? button_type_1.ButtonSize.MEDIUM : _a;
    return sizeHandler(size, {
        default: 16,
        large: 24,
        medium: 24
    });
}, function (props) {
    var _a = props.size, size = _a === void 0 ? button_type_1.ButtonSize.MEDIUM : _a;
    return sizeHandler(size, {
        default: 16,
        large: 24,
        medium: 24
    });
}, function (props) {
    var _a = props.variant, variant = _a === void 0 ? button_type_1.ButtonVariant.PRIMARY : _a;
    return variant === button_type_1.ButtonVariant.PRIMARY ? '#fff' : '#002729';
}, function (props) { return (props.variant === button_type_1.ButtonVariant.PRIMARY ? '#798686' : 'transparent'); }, function (props) { return (props.variant === button_type_1.ButtonVariant.PRIMARY ? 'none' : "".concat((0, size_calculator_1.sizeCalc)(1, 14), " solid #798686")); }, function (props) { return (props.variant === button_type_1.ButtonVariant.PRIMARY ? '#fff' : '#798686'); }, function (props) { return (props.variant === button_type_1.ButtonVariant.PRIMARY ? '#fff' : '#798686'); }, (0, size_calculator_1.sizeCalc)(12, 14), function (props) {
    return props.color === button_type_1.ButtonColor.RED
        ? '#D83C2B radial-gradient(circle, transparent 1%, #D83C2B 1%) center/15000% !important'
        : '#268250 radial-gradient(circle, transparent 1%, #268250 1%) center/15000% !important';
}, function (props) { return (props.color === button_type_1.ButtonColor.RED ? '#E37164' : '#37be74'); });
exports.MiddleAlignedSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  vertical-align: middle;\n  display: inline-block;\n  line-height: ", ";\n"], ["\n  vertical-align: middle;\n  display: inline-block;\n  line-height: ", ";\n"])), function (props) {
    return sizeHandler(props.size, {
        large: 52,
        medium: 47,
        small: 40,
        xSmall: 32,
        xxSmall: 26
    });
});
var templateObject_1, templateObject_2;
